import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { LayoutService } from '@shared/services/layout.service';
import { TourService } from '@shared/services/tour.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-tour-list-dialog',
  templateUrl: './tour-list-dialog.component.html',
  styleUrls: ['./tour-list-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TourListDialogComponent extends BaseComponent implements OnInit {
  readonly toursList$ = this.tourService.toursList$
  readonly counters$ = this.toursList$.pipe(map(list => {
    const visited = list.filter(item => item.isVisited).length;
    const total = list.length;
    return {
      visited: visited || 0,
      total: total || 0,
      percentage: visited ? ((visited * 100) / total) : 0,
    }
  }));


  constructor(
    public layoutService: LayoutService,
    private tourService: TourService,
  ) {
    super()
  }


  ngOnInit(): void {
    this.load(this.tourService.getToursList()).subscribe();
  }

  startTour(tour): void {
    this.tourService.startTour$.next(tour);
  }


}
